import { getRandomNum, updateTime } from '@/utils/index.js'

export function gasType() {
    return [{
        regional: '右洞',
        position: '掌子面',
        name: '硫化氢',
        value: getRandomNum(11,19,2),
        unit: 'ppm',
        highAlarmValue: 20,
        lowAlarmValue: 10,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },{
        regional: '右洞',
        position: '掌子面',
        name: '一氧化碳',
        value: getRandomNum(51,90,2),
        unit: 'ppm',
        highAlarmValue: 100,
        lowAlarmValue: 50,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },{
        regional: '右洞',
        position: '掌子面',
        name: '可燃气',
        value: getRandomNum(0,1,2),
        unit: '%LEL',
        highAlarmValue: 1,
        lowAlarmValue: 0,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },{
        regional: '右洞',
        position: '掌子面',
        name: '氧气',
        value: getRandomNum(20.5,22.5,2),
        unit: '%VOL',
        highAlarmValue: 23.5,
        lowAlarmValue: 19.5,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },{
        regional: '右洞',
        position: '掌子面',
        name: '二氧化氮',
        value: getRandomNum(0,1,2),
        unit: 'ppm',
        highAlarmValue: 1,
        lowAlarmValue: 0,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },{
        regional: '右洞',
        position: '掌子面',
        name: '二氧化碳',
        value: getRandomNum(0,1,2),
        unit: 'ppm',
        highAlarmValue: 1,
        lowAlarmValue: 0,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },{
        regional: '右洞',
        position: '掌子面',
        name: '温度',
        value:getRandomNum(15,20,2),
        unit: '℃',
        highAlarmValue: 50,
        lowAlarmValue: 30,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },{
        regional: '右洞',
        position: '掌子面',
        name: '湿度',
        value: getRandomNum(60,75,2),
        unit: '%',
        highAlarmValue: 100,
        lowAlarmValue: 95,
        tunnelId: '23',
        tunnelNumber: '410a015f9e6241fdb6ed4b4c83b98062',
        creationTime: new Date(),
    },
    {
        regional: '左洞',
        position: '掌子面',
        name: '硫化氢',
        value: getRandomNum(0,1,2),
        unit: 'ppm',
        highAlarmValue: 20,
        lowAlarmValue: 10,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    },{
        regional: '左洞',
        position: '掌子面',
        name: '一氧化碳',
        value: getRandomNum(0,1,2),
        unit: 'ppm',
        highAlarmValue: 100,
        lowAlarmValue: 50,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    },{
        regional: '左洞',
        position: '掌子面',
        name: '可燃气',
        value: getRandomNum(51,90,2),
        unit: '%LEL',
        highAlarmValue: 1,
        lowAlarmValue: 0,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    },{
        regional: '左洞',
        position: '掌子面',
        name: '氧气',
        value: getRandomNum(23.5,24.5,2),
        unit: '%VOL',
        highAlarmValue: 23.5,
        lowAlarmValue: 19.5,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    },{
        regional: '左洞',
        position: '掌子面',
        name: '二氧化氮',
        value: getRandomNum(0,1,2),
        unit: 'ppm',
        highAlarmValue: 1,
        lowAlarmValue: 0,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    },{
        regional: '左洞',
        position: '掌子面',
        name: '二氧化碳',
        value: getRandomNum(0,1,2),
        unit: 'ppm',
        highAlarmValue: 1,
        lowAlarmValue: 0,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    },{
        regional: '左洞',
        position: '掌子面',
        name: '温度',
        value: getRandomNum(15,20,2),
        unit: '℃',
        highAlarmValue: 50,
        lowAlarmValue: 30,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    },{
        regional: '左洞',
        position: '掌子面',
        name: '湿度',
        value: getRandomNum(60,75,2),
        unit: '%',
        highAlarmValue: 100,
        lowAlarmValue: 95,
        tunnelId: '23',
        tunnelNumber: 'cb33117a035e4dedbe10d2ed620e7711',
        creationTime: new Date(),
    }]

}